/* eslint-disable max-len */
const BACKEND_URL = (process.env.REACT_APP_ENV === 'production') ?
  process.env.REACT_APP_BACKEND_URL : 'http://localhost:8000';


export const CONFIG = {
  BACKEND_URL: BACKEND_URL,
  API_URL: `${BACKEND_URL}/api`,
  ALIV_URL: process.env.REACT_APP_ALIV_URL,
  APP_VERSION: process.env.REACT_APP_VERSION
};
